import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../../settings/alight-custom-settings';
import { AlightStateType } from '../../../types/alight-state';

export default class Mutators {
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlightStateType>) {
        this._store = store;
    }

    getMutate() {
        return (parameters: any) => {

            const windowBase = this._store?.getState().Window;
            const isMinimized = windowBase?.IsMinimized;
            const IsEmbedded = windowBase?.IsEmbedded;
            const deviceType = this._store?.getState().DeviceType;
            const className_window = (deviceType === this._settings.mobileConstants.deviceTypes.tablet)
            ? this._settings.classNames.tabletClassName
            : this._settings.classNames.windowClassName;
            const className = (deviceType === this._settings.mobileConstants.deviceTypes.tablet)
                ? this._settings.classNames.launchPointContainerTablet
                : this._settings.classNames.launchPointContainer;

            var launchcontainer: any = document.getElementsByClassName(className);
            var alme_window: any = document.getElementsByClassName(className_window);
            if(!isMinimized) {
                for (let i = 0; i < launchcontainer.length; i++) {
                    let element = launchcontainer[i];
                    element.style.display = "none";
                }
                for (let i = 0; i < alme_window.length; i++) {
                    let element = alme_window[i];
                    element.style.display = "flex";
                }
                return parameters;
            }
            
            for (let i = 0; i < launchcontainer.length; i++) {
                let element = launchcontainer[i];
                element.style.display = "block";
            }
            for (let i = 0; i < alme_window.length; i++) {
                let element = alme_window[i];
                if(!IsEmbedded)
                {
                element.style.display = "none";
                }
            }
            const newParams = {
                className : className,
                style : {},
            };

            return Object.assign({}, parameters, newParams);
        };
    }
}



// WEBPACK FOOTER //
// ./modules/window-launch/renderers/mutator.ts